/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { CRMIntegrationType } from './CRMIntegrationType.js';
import {
    CRMIntegrationTypeFromJSON,
    CRMIntegrationTypeFromJSONTyped,
    CRMIntegrationTypeToJSON,
} from './CRMIntegrationType.js';

/**
 * 
 * @export
 * @interface UpdateCrmIntegrationRequest
 */
export interface UpdateCrmIntegrationRequest {
    /**
     * 
     * @type {any}
     * @memberof UpdateCrmIntegrationRequest
     */
    options?: any;
    /**
     * 
     * @type {CRMIntegrationType}
     * @memberof UpdateCrmIntegrationRequest
     */
    type?: CRMIntegrationType;
    /**
     * 
     * @type {string}
     * @memberof UpdateCrmIntegrationRequest
     */
    inboundScript?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCrmIntegrationRequest
     */
    outboundScript?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCrmIntegrationRequest
     */
    isActive?: boolean;
}

/**
 * Check if a given object implements the UpdateCrmIntegrationRequest interface.
 */
export function instanceOfUpdateCrmIntegrationRequest(value: object): boolean {
    return true;
}

export function UpdateCrmIntegrationRequestFromJSON(json: any): UpdateCrmIntegrationRequest {
    return UpdateCrmIntegrationRequestFromJSONTyped(json, false);
}

export function UpdateCrmIntegrationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCrmIntegrationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'options': json['options'] == null ? undefined : json['options'],
        'type': json['type'] == null ? undefined : CRMIntegrationTypeFromJSON(json['type']),
        'inboundScript': json['inboundScript'] == null ? undefined : json['inboundScript'],
        'outboundScript': json['outboundScript'] == null ? undefined : json['outboundScript'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
    };
}

export function UpdateCrmIntegrationRequestToJSON(value?: UpdateCrmIntegrationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'options': value['options'],
        'type': CRMIntegrationTypeToJSON(value['type']),
        'inboundScript': value['inboundScript'],
        'outboundScript': value['outboundScript'],
        'isActive': value['isActive'],
    };
}

